import React from 'react';
import PropTypes from 'prop-types';

import Progress from './Progress';

function Breadcrumb({ tracks, active, width }) {
  const byItem = (width - (64 * 2) - 30) / tracks.length;
  return (
    <div className={`cf-state-nav v2 flexRow align space-around`}>
      <Progress />
      <div className={`flexRow cf-nav-items-container `} style={{ zIndex: 1 }}>
        {tracks.map((track, i) => (
          <div key={`cf-nav-item${i}`} className={`cf-nav-item-v2 ${(i === active) && `current`} ${(i <= active) && `active`} ${i}`} style={{ width: byItem }} />
        ))}
      </div>
      <span className={`type-regular type-black-5 cf-state-nav-count-v2`}>{`${active + 1} / ${tracks.length}`}</span>
    </div>
  )
}

Breadcrumb.propTypes = {
  tracks: PropTypes.array.isRequired,
  width: PropTypes.number.isRequired,
  active: PropTypes.number.isRequired
}

export default Breadcrumb;
